// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"52e3ad70","279":"560c6696","321":"6d6a7bc6","512":"3f7cec34","537":"f329e24c","875":"4d1b46b4"}[chunkId] + ".chunk.css";
};